import { apm } from '@elastic/apm-rum';
import { getFindUserContextPreferencesKey } from '../../../../services/modules/userContextPreferences/userContextPreferences.keys';
import {
  findUserContextPreferences,
  updateOrCreateFilterPreference,
} from '../../../../services/modules/userContextPreferences/userContextPreferences.repository';
import {
  FilterPreferenceRecognizedLists,
  UserContextPreferences,
} from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { queryClient } from '../../../reactQuery/contexts/QueryClient/utils/queryClient';
import { getRecentBrandIds, pushRecentBrandId, shouldRecordVisit } from './storeConnections.utils';

let pendingVisit: Promise<void> = Promise.resolve();

const visitBrand = async (teamId: string, brandId: string) => {
  const queryKey = [teamId, ...getFindUserContextPreferencesKey()];

  try {
    const preferences = await queryClient.fetchQuery<UserContextPreferences | null>({
      queryKey,
      staleTime: Number.POSITIVE_INFINITY,
      retry: false,
      queryFn: async () => {
        const current = await findUserContextPreferences();

        if (!current.ok) {
          throw current.originalError;
        }

        return current.data ?? null;
      },
    });

    const recentIds = getRecentBrandIds(preferences);

    if (!shouldRecordVisit(recentIds, brandId)) {
      return;
    }

    const response = await updateOrCreateFilterPreference({
      list: FilterPreferenceRecognizedLists.STORE_RECENT_BRANDS,
      defaultFilters: { brandIds: pushRecentBrandId(recentIds, brandId) },
    });

    if (!response.ok) {
      return;
    }

    await queryClient.invalidateQueries({ queryKey });
  } catch (error: any) {
    apm.captureError(error);
  }
};

export const recordBrandVisit = (teamId: string | undefined, brandId: string): Promise<void> => {
  if (!teamId) {
    return Promise.resolve();
  }

  pendingVisit = pendingVisit.then(() => visitBrand(teamId, brandId));

  return pendingVisit;
};
